import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import ArabicRegular from "../../../../../../assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../../../../../assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";
import { RxDotFilled } from "react-icons/rx";
import ArabicComponent from "../../../../../../utils/ArabComponent/ArabicComponent";

const Page2 = ({
  styles,
  Table3DataArabic,
  Table3Data,
  contractDetails,
  firstParty,
  secondParty,
}) => {
  function addSpacesToWord(word) {
    const regex = new RegExp(`.{1,10}`, "g");
    return word.match(regex)?.join(" ");
  }
  console.log("Data to be printed here console", Table3Data, Table3DataArabic);
  return (
    // <Page size="A4" style={styles.page}>
    <>
      {/* <Image
      style={{ marginBottom: 20 }}
      fixed
      source={require("../assets/header.jpg")}
    /> */}
      <Text
        style={{
          marginTop: 15,
          fontFamily: "Helvetica-Bold",
          marginBottom: 20,
          marginRight: 4,
        }}
      >
        ll. TERMS:
        <ArabicComponent arabText={"الفقرة الثانية:"} />
      </Text>
      {/* table 3 */}
      <View style={{ width: "100%", height: 1, borderBottom: 1 }} fixed></View>
      {Table3Data?.map((data, index) => (
        <>
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
            key={index}
          >
            <View style={{ width: "50%", borderRight: 1, padding: 10 }}>
              <Text break>{data.text}</Text>
              {data.sub.map((subItem, subIndex) => (
                <Text key={subIndex} break>
                  . {subItem}
                </Text>
              ))}
            </View>
            <View style={{ width: "50%", borderRight: 1, padding: 10 }}>
              <Text break style={[styles.arabic]}>{Table3DataArabic[index].text}</Text>
              {Table3DataArabic[index].sub.map((subItem, subIndex) => (
                <Text key={subIndex} break style={[styles.arabic]}>
                  . {subItem}
                </Text>
              ))}
            </View>
          </View>
        </>
      ))}

      <Text
        style={{
          marginTop: 15,
          fontFamily: "Helvetica-Bold",
        }}
      >
        lll. INFORMATION SHEET:
      </Text>
      {/* head */}
      <View style={{ marginTop: 10 }}>
        <Text
          style={{
            textAlign: "center",
            backgroundColor: "black",
            color: "white",
            fontSize: 13,
            fontWeight: "Helvetica-Bold",
          }}
        >
          A: FIRST PARTY - INFORMATION
        </Text>
      </View>
      {/* table 5*/}
      <View style={{ borderBottom: 1, marginTop: 0 }}>
        {/* row 1 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>1</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Name of the Company</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.visa_provider?.name}</Text>
          </View>
        </View>
        {/* row 2 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>2</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Address</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.visa_provider?.address}</Text>
          </View>
        </View>
        {/* row 3 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>3</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Head Office Location</Text>
          </View>

          <View style={{ width: "60%", padding: 2 }}>
            <Text break>
              {addSpacesToWord(
                contractDetails?.visa_provider?.head_office_location
              )}
            </Text>
          </View>
        </View>
        {/* row 4 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>4</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Company Registration / CR #</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>
              {contractDetails?.visa_provider?.company_registration}
            </Text>
          </View>
        </View>
        {/* row 5 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>5</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Ministry of Labor License Number</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>
              {contractDetails?.visa_provider?.labor_license_number}
            </Text>
          </View>
        </View>
        {/* row 6 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>6</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Company Sponsor ID (700 series)</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.visa_provider?.sponsor_id}</Text>
          </View>
        </View>
        {/* row 7 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>7</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>VAT Number</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.visa_provider?.vat_number}</Text>
          </View>
        </View>
        {/* row 8 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>8</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>
              Authorized Person to sign the contract (name should be mentioned
              in the CR)
            </Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {contractDetails?.visa_provider?.authorized_person_name}
                </Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Designation</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_person_designation
                  }
                </Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Contact #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {contractDetails?.visa_provider?.authorized_person_contact}
                </Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row" }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>e-mail #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {contractDetails?.visa_provider?.authorized_person_email}
                </Text>
              </View>
            </View>
          </View>
        </View>
        {/* row 9 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>9</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Authorized Project Representative</Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_project_representative_name
                  }
                </Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Designation</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_project_representative_designation
                  }
                </Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Contact #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_project_representative_contact
                  }
                </Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row" }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>e-mail #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_project_representative_email
                  }
                </Text>
              </View>
            </View>
          </View>
        </View>
        {/* row 10 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>10</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Authorized Accounts Representative</Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_accounts_representative_name
                  }
                </Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Designation</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_accounts_representative_designation
                  }
                </Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Contact #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_accounts_representative_contact
                  }
                </Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row" }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>e-mail #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.visa_provider
                      ?.authorized_accounts_representative_email
                  }
                </Text>
              </View>
            </View>
          </View>
        </View>
        {/* row 11 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>11</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, paddingLeft: 2 }}>
            <Text break>Bank Details for Transactions</Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name of Beneficiary</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.visa_provider?.name}</Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name of Bank</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.visa_provider?.bank_name}</Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Branch</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.visa_provider?.bank_branch}</Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Type of Account</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.visa_provider?.bank_type}</Text>
              </View>
            </View>
            {/* subRow 5 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Account #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {contractDetails?.visa_provider?.bank_account_number}
                </Text>
              </View>
            </View>
            {/* subRow 6 */}
            <View
              style={{
                flexDirection: "row",
                paddingLeft: 2,
              }}
              break
            >
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>IBAN #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.visa_provider?.bank_iban}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>

      {/* table 5 copy */}

      <View style={{ marginTop: 10 }}>
        <Text
          style={{
            textAlign: "center",
            backgroundColor: "black",
            color: "white",
            fontSize: 13,
            fontWeight: "Helvetica-Bold",
          }}
        >
          B: SECOND PARTY - INFORMATION
        </Text>
      </View>
      {/* table 5*/}
      <View style={{ borderBottom: 1, marginTop: 0 }}>
        {/* row 1 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>1</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Name of the Company</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.client?.name}</Text>
          </View>
        </View>
        {/* row 2 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>2</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Address</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.client?.address}</Text>
          </View>
        </View>
        {/* row 3 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>3</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Head Office Location</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>
              {addSpacesToWord(contractDetails?.client?.head_office_location)}
            </Text>
          </View>
        </View>
        {/* row 4 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>4</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Company Registration / CR #</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.client?.company_registration}</Text>
          </View>
        </View>
        {/* row 5 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>5</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Ministry of Labor License Number</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.client?.labor_license_number}</Text>
          </View>
        </View>
        {/* row 6 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>6</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Company Sponsor ID (700 series)</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.client?.sponsor_id}</Text>
          </View>
        </View>
        {/* row 7 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>7</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>VAT Number</Text>
          </View>
          <View style={{ width: "60%", padding: 2 }}>
            <Text break>{contractDetails?.client?.vat_number}</Text>
          </View>
        </View>
        {/* row 8 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>8</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>
              Authorized Person to sign the contract (name should be mentioned
              in the CR)
            </Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.authorized_person_name}</Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Designation</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {contractDetails?.client?.authorized_person_designation}
                </Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Contact #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {contractDetails?.client?.authorized_person_contact}
                </Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>e-mail #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.authorized_person_email}</Text>
              </View>
            </View>
          </View>
        </View>
        {/* row 9 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>9</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Authorized Project Representative</Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_project_representative_name
                  }
                </Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Designation</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_project_representative_designation
                  }
                </Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Contact #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_project_representative_contact
                  }
                </Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>e-mail #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_project_representative_email
                  }
                </Text>
              </View>
            </View>
          </View>
        </View>
        {/* row 10 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>10</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
            <Text break>Authorized Accounts Representative</Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_accounts_representative_name
                  }
                </Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Designation</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_accounts_representative_designation
                  }
                </Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Contact #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_accounts_representative_contact
                  }
                </Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>e-mail #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>
                  {
                    contractDetails?.client
                      ?.authorized_accounts_representative_email
                  }
                </Text>
              </View>
            </View>
          </View>
        </View>
        {/* row 11 */}
        <View
          style={{
            flexDirection: "row",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
            borderRight: 1,
          }}
        >
          <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
            <Text break>11</Text>
          </View>
          <View style={{ width: "30%", borderRight: 1, paddingLeft: 2 }}>
            <Text break>Bank Details for Transactions</Text>
          </View>
          <View style={{ width: "65%" }}>
            {/* subRow 1 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name of Beneficiary</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.name}</Text>
              </View>
            </View>
            {/* subRow 2 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Name of Bank</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.bank_name}</Text>
              </View>
            </View>
            {/* subrow 3 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Branch</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.bank_branch}</Text>
              </View>
            </View>
            {/* subRow 4 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Type of Account</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.bank_type}</Text>
              </View>
            </View>
            {/* subRow 5 */}
            <View style={{ flexDirection: "row", borderBottom: 1 }} break>
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>Account #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.bank_account_number}</Text>
              </View>
            </View>
            {/* subRow 6 */}
            <View
              style={{
                flexDirection: "row",
                borderBottom: 1,
                paddingLeft: 2,
              }}
              break
            >
              <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                <Text>IBAN #</Text>
              </View>
              <View style={{ width: "75%", paddingLeft: 2 }}>
                <Text>{contractDetails?.client?.bank_iban}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>

      {/* final table */}
      <View
        style={{
          flexDirection: "row",
          padding: 2,
          backgroundColor: "black",
        }}
        break
      >
        <View style={{ width: "100%" }}>
          <Text
            style={{
              textAlign: "center",
              color: "white",
              fontFamily: "Helvetica-Bold",
            }}
          >
            FIRST PARTY
          </Text>
        </View>
        <View style={{ width: "100%" }}>
          <Text
            style={{
              textAlign: "center",
              color: "white",
              fontFamily: "Helvetica-Bold",
            }}
          >
            SECOND PARTY
          </Text>
        </View>
      </View>
      <View style={{ flexDirection: "row", border: 1, gap: 2 }}>
        <View style={{ width: "100%", padding: 2 }}>
          {firstParty?.map((item, index) => (
            <View key={index} style={{ marginVertical: 10 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  textTransform: "uppercase",
                }}
              >
                {item.title}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Name:</Text>{" "}
                {item.name}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>
                  Designation:
                </Text>
                {item.designation}
              </Text>
              <View style={{ height: 65 }}>
                <Text style={{ textTransform: "uppercase" }}>
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>
                    Signature:
                  </Text>
                  {item.signature}
                </Text>
              </View>
            </View>
          ))}
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Stamp:
            </Text>
          </View>
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Date:
            </Text>
          </View>
        </View>
        <View style={{ width: "100%", padding: 2 }}>
          {secondParty?.map((item, index) => (
            <View key={index} style={{ marginVertical: 10 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  textTransform: "uppercase",
                }}
              >
                {item.title}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Name:</Text>{" "}
                {item.name}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>
                  Designation:
                </Text>
                {item.designation}
              </Text>
              <View style={{ height: 65 }}>
                <Text style={{ textTransform: "uppercase" }}>
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>
                    Signature:
                  </Text>
                  {item.signature}
                </Text>
              </View>
            </View>
          ))}
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Stamp:
            </Text>
          </View>
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Date:
            </Text>
          </View>
        </View>
      </View>
      {/* <Image
      style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}
      fixed
      source={require("../assets/footer.jpg")}
    /> */}
    </>
  );
};

export default Page2;
